import { isRecord } from './parsingHelpers';

/**
 * Normalize Mastra SSE error fields into a user-displayable string.
 * Errors may arrive as plain strings or as objects (e.g. `{ message, name, stack }`).
 */
export const parseErrorTextFromSSE = (
    error: unknown,
    fallback = 'An error occurred',
): string => {
    if (typeof error === 'string' && error.trim() !== '') {
        return error;
    }

    if (
        isRecord(error) &&
        typeof error.message === 'string' &&
        error.message.trim() !== ''
    ) {
        return error.message;
    }

    return fallback;
};

export const getErrorTextFromMastraSSEData = (
    data: { error?: unknown; payload?: { error?: unknown } },
    fallback = 'An error occurred',
): string => {
    if (data.error != null) {
        const parsed = parseErrorTextFromSSE(data.error, '');
        if (parsed !== '') {
            return parsed;
        }
    }

    if (data.payload?.error != null) {
        const parsed = parseErrorTextFromSSE(data.payload.error, '');
        if (parsed !== '') {
            return parsed;
        }
    }

    return fallback;
};
